<template>
  <div>
    <el-card class="mt-3">
      <div slot="header" class="d-flex space-between">
        <h3 class="m-0">Aprobación de Asistencia</h3>
        <div>
          <el-button 
            :disabled="loadingReports"
            @click="fetchReports"
            :loading="loadingReports">
            Refrescar Confirmaciones
          </el-button>
        </div>
      </div>
      <div class="text-right">
      </div>
      <el-alert 
        type="info" 
        title="Advertencia" 
        description="No se encontro ningun reporte de asistencia" 
        v-if="!loadingReports && reports.length == 0">
      </el-alert>
      <el-tabs
        v-model="activeTab"
        v-if="!loadingReports && reports.length > 0"
        type="border-card"
      >
        <el-tab-pane
          v-for="item in reportsSorted"
          :key="item.id"
          :label="item.checkin_name"
          :name="item.id"
          :lazy="true"
          >
          <span slot="label">
           {{ item.checkin_name }}

           <i v-if="item.status == 'Pendiente'" class="el-icon-warning text-warning"></i> 
           <i v-if="item.status == 'Aprobado'" class="el-icon-success text-success"></i> 
           <i v-if="item.status == 'Rechazado'" class="el-icon-error text-danger"></i> 
          </span> 
          <div>
            <el-row>
              <el-col :md="12" class="border-re">
                <h5>Detalles</h5>
                <el-row class="d-flex details">
                  <el-col :sm="8" class="report-detail">
                    <p class="label">Centro de Costo</p>
                    <p>{{ item.cost_center.name }}</p>
                  </el-col> 
                  <el-col :sm="8" class="report-detail">
                    <p class="label">Creado el</p>
                    <p>{{ item.created_at }}</p>
                  </el-col> 
                  <el-col :sm="8" class="report-detail">
                    <p class="label">Responsable</p>
                    <p>{{ item.user.name }}</p>
                  </el-col> 
                  <el-col :sm="8" class="report-detail">
                    <p class="label">Estado</p>
                    <p>
                    <el-tag :type="item.tag_type">
                      {{ item.status }}
                    </el-tag>
                    </p>
                  </el-col> 
                  <el-col :sm="8" class="report-detail">
                    <p class="label">Revisión</p>
                    <p>{{ item.revision_count }}</p>
                  </el-col> 
                  <el-col :sm="8" class="report-detail">
                    <p class="label">N. Colaboradores</p>
                    <p>{{ item.total }}</p>
                  </el-col> 
                </el-row>
              </el-col>

              <el-col :md="12">
                <checkin-report-observations 
                  :ref="'observations-' + item.id"
                  :report-id="item.id" ></checkin-report-observations>
              </el-col>

            </el-row>

            <h5 class="mt-3">Reporte de Asistencia del {{ item.init_date }} al {{ item.end_date}} </h5>
            <checkin-revision-table 
              :report-id="item.id" 
              :headers="item.recordHeaders"  
              :disabled="item.status != 'Pendiente'"
              @report-updated="updateReport($event, item)"
              @update-table="updateTotal($event, item)"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import moment from 'moment'
import { baseApi } from '../../../configs/urls'
import { parseError } from '../../../packages/Helpers'
import CheckinRevisionTable from './CheckinRevisionTable'
import CheckinReportObservations from './CheckinReportObservations'
export default {
  components: {
    CheckinRevisionTable,
    CheckinReportObservations
  },
  data () {
    return {
      tagTypes: {
        'Rechazado': 'danger',
        'Aprobado': 'success',
        'Pendiente': 'warning'
      },
      order: {
        'Pendiente': 1,
        'Rechazado': 2,
        'Aprobado': 3
      },
      loadingReports: false,
      reports: [],
      activeTab: '1'
    }
  },
  computed: {
    reportsSorted () {
      return this.reports.sort((r1, r2) => {
        return this.order[r1.status] - this.order[r2.status]
      })
    }
  },
  methods: {
    updateTotal (total, item) {
      item.total = total
    },
    updateReport (report, item) {
      item.status = report.status
      item.tag_type = this.tagTypes[report.status]
      if (report.approve_user) {
        item.approve_user = report.approve_user
      }
      const reports = this.reportsSorted
      if (reports.length > 0 && reports[0].status === 'Pendiente') {
        this.activeTab = reports[0].id.toString()
      }

      const ref = 'observations-' + item.id
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        this.$refs[ref][0].fetchObservations()
      }
    },
    fetchReports () {
      if (this.loadingReports) {
        return
      }

      this.loadingReports = true
      this.reports = []
      this.$http.get(baseApi + '/checkins-report')
        .then(
          (res) => {
            this.reports = res.body.map((report) => {
              report.id = report.id.toString()
              report.records = []

              const headers = []
              const initDate = moment(report.init_date)
              const endDate = moment(report.end_date)

              while (initDate.isSameOrBefore(endDate, 'day')) {
                headers.push(initDate.format('MM-DD'))
                initDate.add(1, 'days')
              }

              report.recordHeaders = headers
              report.tag_type = this.tagTypes[report.status]
              report.total = 0
              report.lodingObservations = false
              report.observations = []
              return report
            })
            this.loadingReports = false
            if (this.reports.length > 0) {
              this.activeTab = this.reportsSorted[0].id
            }
          },
          (res) => {
            this.loadingReports = false
            if (res.status !== 0) {
              this.$message.error(parseError(res)[0])
            }
          }
        )
    }
  },
  mounted () {
    this.fetchReports()
  }
}
</script>
<style lang="scss" scoped>
  .border-red {
    border: 1px solid red; 
  }
  .details {
    flex-wrap: wrap;

    .report-detail {
      .label {
        text-transform: uppercase;
        color: #2B94B6;
        font-size: 0.8rem;
        margin-top: 0;
      }
      p:not(.label) {
        color:black;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/views/checkins/approval/ApprovalPage.vue